"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var _formatting = require("../../../helpers/formatting");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var User = function User(_ref) {
  var user = _ref.user,
    on = _ref.on,
    mobile = _ref.mobile;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--user inline-flex flex-column flex-center"
  }, user ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, user.name && /*#__PURE__*/_react["default"].createElement("a", {
    className: "inline-block margin-right-xs@sm",
    href: "/account"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    avatarSize: on ? _constants.AVATAR_SIZES.SMALL : _constants.AVATAR_SIZES.SMALL,
    avatarColor: _constants.AVATAR_COLORS.SECONDARY,
    image: user.fbUid ? {
      url: "https://graph.facebook.com/v2.9/".concat(user.fbUid, "/picture?type=square"),
      alt: user.name
    } : user.gravatarImageUrl && {
      url: user.gravatarImageUrl,
      alt: user.name
    },
    initials: (0, _formatting.getInitialsFromName)(user.firstName, user.lastName)
  }))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mobile ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "user",
    buttonType: _constants.BUTTON_TYPES.BARE_NO_PADDING,
    className: "user-placeholder",
    link: "/account/login",
    buttonSize: _constants.BUTTON_SIZES.XXXLARGE
  }) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-right-xs",
    text: "Log in",
    iconFlip: true,
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    link: "/account/login"
  })), on && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-xs d8-u-color-contrast-high d8-u-text-semi-bold"
  }, "Profile"), " ");
};
User.propTypes = {
  user: _propTypes["default"].object,
  on: _propTypes["default"].bool,
  mobile: _propTypes["default"].bool
};
var _default = exports["default"] = User;